import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Photographer} from '../../entities/photographer/photographer.entity';
import {environment} from '../../../../environments/environment';
import {PaginatedResponse} from '../../../core/entities/utils/paginated-response.entity';
import {LanguageService} from '../../../core/services/language/language.service';

@Injectable({
  providedIn: 'root'
})
export class PhotographerService
{
  public constructor(
    private readonly http: HttpClient,
    private readonly languageService: LanguageService,
  ) {
  }

  public getPhotographer(slug: string): Observable<Photographer> {
    const lang = this.languageService.getWebsiteLanguage();
    const params = new HttpParams().set('lang', lang);
    return this.http.get<Photographer>(
      `${environment.apiUrl}/marketplace/photographer/${slug}`,
      { params }
    );
  }

  public getPhotographers(
    city: string|null = null,
    tags: string[]|null = null,
    page: number = 0,
    limit: number = 20,
  ): Observable<PaginatedResponse<Photographer>> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('limit', limit.toString());

    if (city !== null) {
      params = params.set('city', city);
    }

    if (tags !== null) {
      tags.forEach(tag => {
        params = params.append('tags[]', tag);
      });
    }

    return this.http.get<PaginatedResponse<Photographer>>(`${environment.apiUrl}/marketplace/photographer`, { params });
  }
}
